const newLpPage = () => import('./NewLogisticProviderPage.vue');

export default {
  name: 'new-logistic-provider-page',
  path: 'self-service/new-lp',
  component: newLpPage,
  meta: {
    title: 'Nova Transportadora',
  },
  props: true,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/logistic-provider-form/routes.js